import leadPlan from './leadPlan'
export default leadPlan
